var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-warpper"},[_c('iframe',{staticClass:"iframe",attrs:{"id":"inputIFrameId","height":"400px","width":"100%","frameborder":"0","scrolling":"no","src":"/kityformula/index.html"}})])
}]

export { render, staticRenderFns }